export default __webpack_public_path__ + "static/media/utkarsh_details_image.7380af6f.png";